module.exports = __webpack_public_path__ + "static/media/25UNHCR4.61cd4637.jpg";